debugMode && console.log('custom scripts loaded from bibb2022_7/js/scripts.js');

// add css-classes to il-layout-page element
let classname = " ";

console.log('add classes');

(function addClasses() {
  if (window.location.href.indexOf("login.php") > -1) {
    classname += "login-page";
  } else {
    const urlParams = new URLSearchParams(window.location.search);
    urlParamsHas(urlParams, 'cmdClass', ' page');
    urlParamsHas(urlParams, 'root', ' ref_id');
    isLoggedIn();
    if (isLoggedIn()) {
      detectAdminPage();
    }
  }
  document.getElementsByClassName("il-layout-page").item(0).className += classname;
})();

const isAdmin = document.querySelector('.role-administrator');

if (!isAdmin) {
  hideHeaderOnCondition('_copa_');
}


hideBreadcrumbsInStartpage();

hideInfoMenu();

addClassBookingTable();

//load mobilemenu element
// inside of content style element mobileMenu
const mobileMenu = document.querySelector('.ilc_section_mobileMenu');

if (mobileMenu) {
  setTimeout(
    loadMobileMenuTemplate(), 800
  );
}
